import {
  getTokens,
  setTokens,
  errorCodeHandler,
  errorMessageHandler,
  errorMessageHandlerCustom,
  refreshAuthToken,
  unsetTokens,
  unauthorizedLogout,
} from "apis";
import { isLoading, displayError } from "helpers";

export const publicFetch = (url, options, loading = true) => {
  loading && isLoading(true);
  // console.log("Using public fetch");

  return new Promise((resolve, reject) => {
    let opts = {
      ...options,
      // mode: 'no-cors',
      headers: new Headers({
        "Content-Type": "application/json",
      }),
    };

    fetch(url, opts)
      .then((res) => res.json())
      .then(errorMessageHandler)
      .then((res) => {
        loading && isLoading(false);
        resolve(res);
      })
      .catch((error) => {
        loading && isLoading(false);
        displayError(error);
        reject(error);
      });
  });
};

export const publicFetchWithTokenHandler = (url, options, loading = true) => {
  loading && isLoading(true);
  // console.log("Using public fetch");

  return new Promise((resolve, reject) => {
    let opts = {
      ...options,
      // mode: 'no-cors',
      headers: new Headers({
        "Content-Type": "application/json",
      }),
    };

    fetch(url, opts)
      .then(setTokens)
      .then((res) => res.json())
      .then(errorMessageHandler)
      .then((res) => {
        loading && isLoading(false);
        resolve(res);
      })
      .catch((error) => {
        loading && isLoading(false);
        displayError(error);
        reject(error);
      });
  });
};

export const publicFetchNoJSONAndNoText = (url, options, loading = true) => {
  loading && isLoading(true);
  // console.log("Using public fetch");

  return new Promise((resolve, reject) => {
    let opts = {
      ...options,
      // mode: 'no-cors',
      // headers: new Headers({
      //   "Content-Type": "application/json",
      // }),
    };

    fetch(url, opts)
      // .then((res) => res.json())
      .then(errorMessageHandler)

      .then((res) => {
        loading && isLoading(false);
        resolve(res);
      })
      .catch((error) => {
        loading && isLoading(false);
        displayError(error);
        reject(error);
      });
  });
};

export const publicFetchNoJSON = (url, options, loading = true) => {
  loading && isLoading(true);
  // console.log("Using public fetch");

  return new Promise((resolve, reject) => {
    let opts = {
      ...options,
      // mode: 'no-cors',
      // headers: new Headers({
      //   "Content-Type": "application/json",
      // }),
    };

    fetch(url, opts)
      // .then((res) => res.json())
      .then((res) => res.text())
      .then(errorMessageHandler)

      .then((res) => {
        loading && isLoading(false);
        resolve(res);
      })
      .catch((error) => {
        loading && isLoading(false);
        displayError(error);
        reject(error);
      });
  });
};

export const privateFetch = (
  url,
  options,
  loading = true,
  showError = true
) => {
  loading && isLoading(true);

  return new Promise((resolve, reject) => {
    let opts = {
      ...options,
      // mode: 'no-cors',
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: getTokens().Authorization,
      }),
    };

    fetch(url, opts)
      .then(errorCodeHandler)
      .then((res) => res.json())
      .then(errorMessageHandler)
      .then((res) => {
        loading && isLoading(false);
        resolve(res);
      })
      .catch((error) => {
        loading && isLoading(false);
        if (error === "PerformRefreshToken") {
          refreshAuthToken()
            .then(() => {
              resolve(privateFetch(url, options));
            })
            .catch(reject);
        } else if (error === "PerformUnauthorizedToken") {
          displayError("Session Expired");
          unauthorizedLogout();
        } else if (error === "GenericError") {
          displayError("There was an issue processing your request.");
        } else {
          showError && displayError(error);
          reject(error);
        }
      });
  });
};

export const privateFetchCustomErrorHandling = (
  url,
  options,
  loading = true,
  showError = true
) => {
  loading && isLoading(true);

  return new Promise((resolve, reject) => {
    let opts = {
      ...options,
      // mode: 'no-cors',
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: getTokens().Authorization,
      }),
    };

    fetch(url, opts)
      .then(errorCodeHandler)
      .then((res) => res.json())
      .then(errorMessageHandlerCustom)
      .then((res) => {
        loading && isLoading(false);
        resolve(res);
      })
      .catch((error) => {
        loading && isLoading(false);
        if (error === "PerformRefreshToken") {
          refreshAuthToken()
            .then(() => {
              resolve(privateFetch(url, options));
            })
            .catch(reject);
        } else if (error === "PerformUnauthorizedToken") {
          displayError("Session Expired");
          unauthorizedLogout();
        } else if (error === "GenericError") {
          displayError("There was an issue processing your request.");
        } else {
          showError && displayError(error);
          reject(error);
        }
      });
  });
};

export const privateFetchWithToken = (
  url,
  options,
  loading = true,
  showError = true
) => {
  loading && isLoading(true);

  return new Promise((resolve, reject) => {
    let opts = {
      ...options,
    };

    fetch(url, opts)
      .then(errorCodeHandler)
      .then((res) => res.json())
      .then(errorMessageHandler)
      .then((res) => {
        loading && isLoading(false);
        resolve(res);
      })
      .catch((error) => {
        loading && isLoading(false);
        if (error === "PerformRefreshToken") {
          refreshAuthToken()
            .then(() => {
              resolve(privateFetch(url, options));
            })
            .catch(reject);
        } else if (error === "PerformUnauthorizedToken") {
          displayError("Session Expired");
          unauthorizedLogout();
        } else if (error === "GenericError") {
          displayError("There was an issue processing your request.");
        } else {
          showError && displayError(error);
          reject(error);
        }
      });
  });
};

export const privateFetchNoBody = (url, options, loading = true) => {
  loading && isLoading(true);

  return new Promise((resolve, reject) => {
    let opts = {
      ...options,
      // mode: 'no-cors',
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: getTokens().Authorization,
      }),
    };

    fetch(url, opts)
      .then(errorCodeHandler)
      .then(errorMessageHandler)
      .then((res) => {
        loading && isLoading(false);
        if (res.status === 200) return resolve(true);
        return reject(`Error: ${url}`);
      })
      .catch((error) => {
        loading && isLoading(false);
        if (error === "PerformRefreshToken") {
          refreshAuthToken()
            .then(() => {
              resolve(privateFetch(url, options));
            })
            .catch(reject);
        } else if (error === "PerformUnauthorizedToken") {
          displayError("Session Expired");
          unauthorizedLogout();
        } else {
          displayError(error);
          reject(error);
        }
      });
  });
};

export const privateFetchFormFields = (
  url,
  options,
  loading = true,
  showError = true
) => {
  loading && isLoading(true);

  return new Promise((resolve, reject) => {
    let opts = {
      ...options,
      // mode: 'no-cors',
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: getTokens().Authorization,
      }),
    };

    fetch(url, opts)
      .then(errorCodeHandler)
      .then((res) => res.json())
      .then(errorMessageHandler)
      .then((res) => {
        loading && isLoading(false);
        resolve(res);
      })
      .catch((error) => {
        loading && isLoading(false);
        if (error === "PerformRefreshToken") {
          refreshAuthToken()
            .then(() => {
              resolve(privateFetch(url, options));
            })
            .catch(reject);
        } else if (error === "PerformUnauthorizedToken") {
          displayError("Session Expired");
          unauthorizedLogout();
        } else if (error === "GenericError") {
          displayError("There was an issue processing your request.");
        } else {
          showError && displayError(error);
          reject(error);
        }
      });
  });
};

export const privateFetchNoBodyNoJson = (url, options, loading = true) => {
  loading && isLoading(true);

  return new Promise((resolve, reject) => {
    let opts = {
      ...options,
      // mode: 'no-cors',
      headers: new Headers({
        Authorization: getTokens().Authorization,
      }),
    };

    fetch(url, opts)
      .then(errorCodeHandler)
      .then(errorMessageHandler)
      .then((res) => {
        loading && isLoading(false);
        if (res.status === 200) return resolve(res);
        return reject(`Error: ${url}`);
      })
      .catch((error) => {
        loading && isLoading(false);
        if (error === "PerformRefreshToken") {
          refreshAuthToken()
            .then(() => {
              resolve(privateFetch(url, options));
            })
            .catch(reject);
        } else if (error === "PerformUnauthorizedToken") {
          displayError("Session Expired");
          unauthorizedLogout();
        } else {
          displayError(error);
          reject(error);
        }
      });
  });
};
export const privateFetchJson = (url, options, loading = true) => {
  loading && isLoading(true);

  return new Promise((resolve, reject) => {
    let opts = {
      ...options,
      // mode: 'no-cors',

      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: getTokens().Authorization,
      }),
    };

    fetch(url, opts)
      .then(errorCodeHandler)
      .then(errorMessageHandler)
      .then((res) => {
        // console.log(res);
        loading && isLoading(false);
        return resolve(res);
        if (res.status === 200) return resolve(res);
        return reject(`Error: ${url}`);
      })
      .catch((error) => {
        loading && isLoading(false);
        if (error === "PerformRefreshToken") {
          refreshAuthToken()
            .then(() => {
              resolve(privateFetch(url, options));
            })
            .catch(reject);
        } else if (error === "PerformUnauthorizedToken") {
          displayError("Session Expired");
          unauthorizedLogout();
        } else {
          displayError(error);
          reject(error);
        }
      });
  });
};
